import { CommonUIModule } from '../webpack';
/** @component React Components */
export const ToggleField = Object.values(CommonUIModule).find((mod) => mod?.render?.toString()?.includes('ToggleField,fallback'));
